var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "row flex flex-col justify-center pb-0 overflow" },
    [
      _c("div", { staticClass: "w-12/12 md:max-w-full text-center roboto" }, [
        _vm.message &&
        (_vm.isCableAccessoriesPage ||
          _vm.cablesNeededCount !== _vm.totalCablesSubmittedCount)
          ? _c(
              "div",
              {
                ref: "selectionWrapper",
                staticClass: "error-message-wrapper",
                class: _vm.messageWrapperClass,
              },
              [
                _c("div", { staticClass: "error-title-wrapper" }, [
                  _c("div", { staticClass: "flex" }, [
                    _c("div", { staticClass: "error-circle" }, [_vm._v("!")]),
                    _vm._v(" "),
                    _c("h3", { staticClass: "!text-base" }, [
                      _vm._v(
                        _vm._s(
                          _vm.messageType === "general" ||
                            _vm.isCableAccessoriesPage
                            ? "Error with your entry"
                            : `${
                                _vm.cablesNeededCount -
                                _vm.totalCablesSubmittedCount
                              } of ${_vm.cablesNeededCount} cables have errors`
                        )
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _vm.message
                  ? _c("p", { staticClass: "message" }, [
                      _vm._v(_vm._s(_vm.message)),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.action && _vm.action.text
                  ? _c(
                      "button",
                      {
                        staticClass: "change-button",
                        on: { click: _vm.action.action },
                      },
                      [_vm._v(_vm._s(_vm.action.text))]
                    )
                  : _vm._e(),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.totalCablesSubmittedCount > 0
          ? _c(
              "div",
              {
                ref: "selectionWrapper",
                staticClass: "selected-cable-wrapper",
              },
              [
                _c("h3", [_vm._v("Cable Selections")]),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticClass: "cable-list" },
                  _vm._l(_vm.totalCompiledData, function (info, name) {
                    return _c(
                      "li",
                      {
                        key: name,
                        staticClass: "info-wrapper flex mt-1 text-left",
                      },
                      [
                        _c(
                          "p",
                          {
                            staticClass:
                              "text-base min-w-[45px] dark-blue-text font-normal mt-0 ml-1 mr-2",
                          },
                          [_vm._v("Qty: " + _vm._s(info.qty))]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "product-info" }, [
                          _c(
                            "p",
                            {
                              staticClass:
                                "text-base font-medium dark-blue-text mt-0",
                              staticStyle: { "line-height": "140%" },
                            },
                            [_vm._v(_vm._s(name))]
                          ),
                          _vm._v(" "),
                          info && info.list && info.list.length > 0
                            ? _c(
                                "p",
                                {
                                  staticClass:
                                    "text-sm dark-blue-text subtext font-normal -mt-0.5",
                                },
                                [
                                  _vm._v("for \n                            "),
                                  _vm._l(info.list, function (value, index) {
                                    return _c("span", { key: value }, [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            value.replace("undefined", "")
                                          ) +
                                          _vm._s(
                                            index !== info.list.length - 1
                                              ? ","
                                              : ""
                                          ) +
                                          "\n                            "
                                      ),
                                    ])
                                  }),
                                ],
                                2
                              )
                            : _vm._e(),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _vm.isCableAccessoriesPage && _vm.totalCablesSubmittedCount > 0
                  ? _c("v-button", {
                      staticClass: "w-12/12 button-wrap !mb-0 h-fit",
                      class: _vm.index === 0 && "disabled",
                      attrs: {
                        position: "left",
                        mobile: "12",
                        tablet: "12",
                        desktop: "12",
                        styling: "tertiary",
                        disabled: false,
                        textAlign: "left",
                      },
                      on: { onClickEvent: _vm.clearTotalCablesSubmittedData },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "content",
                            fn: function () {
                              return [
                                _c(
                                  "span",
                                  { staticClass: "flex items-center" },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        staticClass: "inline",
                                        attrs: {
                                          width: "14",
                                          height: "18",
                                          viewBox: "0 0 14 18",
                                          fill: "none",
                                          xmlns: "http://www.w3.org/2000/svg",
                                        },
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d: "M1 16C1 17.1 1.9 18 3 18H11C12.1 18 13 17.1 13 16V4H1V16ZM14 1H10.5L9.5 0H4.5L3.5 1H0V3H14V1Z",
                                            fill: "#0D6EDE",
                                          },
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "underline" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.webstoreContent.cartPage.clearAll
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        3255388393
                      ),
                    })
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }